import { render, staticRenderFns } from "./DimensionExtItem.vue?vue&type=template&id=4fe51b6d&scoped=true"
import script from "./DimensionExtItem.vue?vue&type=script&lang=js"
export * from "./DimensionExtItem.vue?vue&type=script&lang=js"
import style0 from "./DimensionExtItem.vue?vue&type=style&index=0&id=4fe51b6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe51b6d",
  null
  
)

export default component.exports